const products = [
  {
    id: 'vpn',
    name: 'KONUS VPN',
    tagline: 'Secure. Private. Fast.',
    description:
      'Military-grade encryption that shields your online activity from trackers, hackers, and data brokers. Browse freely on any network with zero-log policy.',
    highlights: ['256-bit AES Encryption', 'Zero-Log Policy', 'Global Server Network', 'Kill Switch Protection'],
    image:
      'https://public.readdy.ai/ai/img_res/ef1e7ab6f5f4005868ad740c5105b21e.jpg',
    accent: 'from-teal-700 to-teal-500',
    badge: 'bg-teal-600',
  },
  {
    id: 'cleaner',
    name: 'KONUS Cleaner',
    tagline: 'Clean. Optimize. Boost.',
    description:
      'Reclaim storage space and supercharge your iPhone\'s performance. Intelligently removes junk files, duplicate photos, and unnecessary caches.',
    highlights: ['Smart Junk Removal', 'Duplicate Photo Finder', 'Memory Optimizer', 'Battery Health Monitor'],
    image:
      'https://readdy.ai/api/search-image?query=iOS%20cleaner%20app%20concept%20art%2C%20clean%20sparkle%20effect%20with%20abstract%20particles%20and%20geometric%20shapes%2C%20warm%20coral%20and%20orange%20gradient%20background%2C%20minimalist%20mobile%20app%20aesthetic%2C%20no%20text%2C%20high%20quality%20digital%20art&width=600&height=700&seq=cleaner001&orientation=portrait',
    accent: 'from-orange-500 to-rose-500',
    badge: 'bg-orange-500',
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16 md:mb-20">
          <p className="text-xs uppercase tracking-[0.2em] text-teal-600 font-semibold mb-4">
            What We Build
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Our Products
          </h2>
          <p className="text-gray-500 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
            Two powerful iOS applications built to protect your privacy and keep your device running at its best.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {products.map((p) => (
            <div
              key={p.id}
              className="group rounded-2xl overflow-hidden bg-gray-50 hover:bg-white transition-all duration-300"
            >
              {/* Image */}
              <div className="relative w-full h-72 md:h-80 overflow-hidden">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-t ${p.accent} opacity-40`} />
                <span className={`absolute top-4 left-4 ${p.badge} text-white text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wider`}>
                  iOS App
                </span>
              </div>

              {/* Content */}
              <div className="p-7 md:p-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-1">{p.name}</h3>
                <p className="text-sm font-medium text-teal-600 mb-4">{p.tagline}</p>
                <p className="text-gray-600 text-sm leading-relaxed mb-6">{p.description}</p>

                <ul className="grid grid-cols-2 gap-2">
                  {p.highlights.map((h) => (
                    <li key={h} className="flex items-center gap-2 text-sm text-gray-700">
                      <span className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-check-line text-teal-500 text-base" />
                      </span>
                      {h}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
